import { Footer2018 } from './footer';
import { use2018Assets } from './shared';

const SmartCity2018 = () => {
  use2018Assets({ lang: 'en', title: 'Hong Kong Smart City Summit cum Smart City Awards 2018' });

  return (
    <>
      <div id="Lightbox">
        <div className="spinner">
          <div className="dot1" />
          <div className="dot2" />
        </div>
      </div>

      <div className="menu_container" id="menu_container">
        <div className="topnav" id="myTopnav">
          <a href="/2018" className="topnav_logo" id="topnav_logo">
            <img src="/2018/images/head_logo_2.png" alt="" />
          </a>
          <div className="tab_container" id="tab_container">
            <a href="/2018" id="tab_home">
              HOME
            </a>
            <a href="/2018/agenda">SUMMIT</a>
            <a href="/2018/awards" className="tab_awards">
              AWARDS
            </a>
            <a href="/2018/winners" className="tab_winners">
              WINNERS
            </a>
            <a href="/2018/advisory">ADVISORY BOARD</a>
            <div className="dropdown">
              <a href="#" className="dropbtn">
                JUDGING
              </a>
              <div className="dropdown-content">
                <a href="/2018/judges">JUDGES</a>
                <a href="/2018/judges_criteria">JUDGING CRITERIA</a>
              </div>
            </div>
            <a href="/2018/sponsors">SPONSORS</a>
            <a href="/2018/highlights">HIGHLIGHTS</a>
            <div className="language container" id="language">
              <div className="lang_icon">
                <img src="/2018/images/lang_icon.png" alt="" />
              </div>
              <a
                href="/2018/zh"
                className="language_ch"
                style={{
                  fontFamily: 'Microsoft JhengHei',
                  padding: 0,
                  paddingLeft: 6,
                  textAlign: 'center',
                  color: '#004fad',
                  position: 'absolute',
                  borderBottom: 0,
                  display: 'inline-block',
                }}
              >
                中
              </a>
              <a
                href="/2018"
                className="language_ch"
                style={{
                  fontFamily: 'Poppins',
                  padding: 0,
                  paddingLeft: 6,
                  textAlign: 'center',
                  color: '#004fad',
                  position: 'absolute',
                  borderBottom: 0,
                  display: 'none',
                }}
              >
                En
              </a>
            </div>
          </div>
          <a
            id="click"
            href="#"
            style={{ fontSize: 15 }}
            className="icon"
            onClick={(e) => {
              e.preventDefault();
              (window as any).myFunction?.();
            }}
          >
            <i className="fa fa-bars" />
          </a>
        </div>
      </div>

      <div id="larger_wrapper">
        <div className="wrapper">
          <div className="head_banner">
            <div className="KV">
              <div id="slideshow">
                <div className="KV_envir a">
                  <img src="/2018/images/SCA_KV_envir_a.jpg" alt="" />
                  <div className="KV_envir b">
                    <img src="/2018/images/SCA_KV_envir_b-min.png" alt="" />
                  </div>
                  <div className="KV_envir c">
                    <img src="/2018/images/SCA_KV_envir_c-min.png" alt="" />
                  </div>
                </div>
                <div className="KV_gov a">
                  <img src="/2018/images/SCA_KV_gov_a.jpg" alt="" />
                  <div className="KV_gov b">
                    <img src="/2018/images/SCA_KV_gov_b-min.png" alt="" />
                  </div>
                  <div className="KV_gov c">
                    <img src="/2018/images/SCA_KV_gov_c-min.png" alt="" />
                  </div>
                </div>
                <div className="KV_liv a">
                  <img src="/2018/images/SCA_KV_liv_a.jpg" alt="" />
                  <div className="KV_liv b">
                    <img src="/2018/images/SCA_KV_liv_b-min.png" alt="" />
                  </div>
                  <div className="KV_liv d">
                    <img src="/2018/images/SCA_KV_liv_d-min.png" alt="" />
                  </div>
                  <div className="KV_liv c">
                    <img src="/2018/images/SCA_KV_liv_c-min.png" alt="" />
                  </div>
                </div>
                <div className="KV_econ a">
                  <img src="/2018/images/SCA_KV_econ_a.jpg" alt="" />
                  <div className="KV_econ b">
                    <img src="/2018/images/SCA_KV_econ_b-min.png" alt="" />
                  </div>
                  <div className="KV_econ c">
                    <img src="/2018/images/SCA_KV_econ_c-min.png" alt="" />
                  </div>
                  <div className="KV_econ d">
                    <img src="/2018/images/SCA_KV_econ_d-min.png" alt="" />
                  </div>
                </div>
                <div className="KV_peo a">
                  <img src="/2018/images/SCA_KV_peo_a.jpg" alt="" />
                  <div className="KV_peo b">
                    <img src="/2018/images/SCA_KV_peo_b-min.png" alt="" />
                  </div>
                  <div className="KV_peo c">
                    <img src="/2018/images/SCA_KV_peo_c-min.png" alt="" />
                  </div>
                  <div className="KV_peo d">
                    <img src="/2018/images/SCA_KV_peo_d-min.png" alt="" />
                  </div>
                </div>
                <div className="KV_mob a">
                  <img src="/2018/images/SCA_KV_mob_a.jpg" alt="" />
                  <div className="KV_mob b">
                    <img src="/2018/images/SCA_KV_mob_b-min.png" alt="" />
                  </div>
                  <div className="KV_mob c">
                    <img src="/2018/images/SCA_KV_mob_c-min.png" alt="" />
                  </div>
                  <div className="KV_mob d">
                    <img src="/2018/images/SCA_KV_mob_d-min.png" alt="" />
                  </div>
                  <div className="KV_mob e">
                    <img src="/2018/images/SCA_KV_mob_e-min.png" alt="" />
                  </div>
                </div>
              </div>
            </div>

            <div id="typing">
              <h3>
                Smart{' '}
                <span
                  className="txt-rotate"
                  style={{ fontWeight: 600 }}
                  data-period="2000"
                  data-rotate='["Environment.", "Government.", "Living.", "Economy.", "People.", "Mobility."]'
                />
                <span className="typed-cursor" style={{ animationIterationCount: 'infinite' }}>
                  |
                </span>
              </h3>
              <h2>
                A single <span> &lt;span&gt; </span> is all you need.
              </h2>
            </div>
          </div>

          <div className="left_head_banner">
            <div className="small_wrapper">
              <a href="/2018" className="head_logo">
                <img src="/2018/images/head_logo.png" alt="" />
              </a>
              <div className="tagline">
                Smarter<br />
                Innovations
                <br />
                for a Better<br />
                Hong Kong.
                <div className="scroll_down">
                  DISCOVER
                  <div className="scroll_down_arrow">
                    <img src="/2018/images/scroll_down_arrow.png" alt="" />
                  </div>
                </div>
              </div>
            </div>

            <div className="small_wrapper_mobile">
              <div className="head_logo_mobile">
                <img src="/2018/images/head_logo.png" alt="" />
              </div>
              <div className="tagline">
                Smarter<br />
                Innovations
                <br />
                for a Better<br />
                Hong Kong.
                <div className="scroll_down">
                  DISCOVER
                  <div className="scroll_down_arrow">
                    <img src="/2018/images/scroll_down_arrow.png" alt="" />
                  </div>
                </div>
              </div>
            </div>

            <div className="blue_bg">
              <img src="/2018/images/blue_bg_2.png" alt="" />
            </div>
            <div className="blue_bg_mobile" />
          </div>
        </div>
      </div>

      <div className="wave_bg">
        <img src="/2018/images/wave-top.png" alt="" />
      </div>
      <div className="wave_bg_pattern" />

      <div className="para_introduction">
        <h1>Hong Kong Smart City Summit cum Smart City Awards 2018</h1>
        <div className="first_intro">
          <div className="center_introduction">
            <p className="p1">
              Smart City development can improve people’s daily living and make Hong Kong a liveable city. In Smart City
              Blueprint published in mid-2017, the consultant recommended a series of short, medium and long-term initiatives
              under six areas, namely <b>“Smart Mobility”, “Smart Living”, “Smart Environment”, “Smart People”, “Smart
              Government” and “Smart Economy”</b>, the accomplishment of which requires the collaboration between the
              government, businesses and community groups.
              <br />
              <br />
              Hong Kong has an advantage in developing into a smart city, given its density, advanced IT connectivity, openness,
              excellent infrastructure, international exposure and the experience of the stakeholders. In Hong Kong, we need
              the business community and the people to be empowered to realise a “smart” future.
            </p>
          </div>
          <div className="six_cate">
            <div className="animate cate_container" data-animate="bounceIn" data-duration="1.0s" data-delay="0.1s" data-offset="100">
              <img src="/2018/images/smart_mobility.png" alt="" />
              <img src="/2018/images/smart_living.png" alt="" />
              <img src="/2018/images/smart_environment.png" alt="" />
              <img src="/2018/images/smart_people.png" alt="" />
              <img src="/2018/images/smart-government.png" alt="" />
              <img src="/2018/images/smart_economy.png" alt="" />
            </div>
          </div>
        </div>

        <div className="youtubevideowrap">
          <div className="video_container">
            <iframe
              src="https://www.youtube.com/embed/k-kj3cTFGMo?showinfo=0&rel=0"
              frameBorder={0}
              allowFullScreen
            />
          </div>
        </div>

        <div className="aim_bg">
          <div className="aim_event_container">
            <div className="aim_event_wrap">
              <div className="animate aim_text" data-animate="slideInLeft" data-duration="1.0s" data-delay="0.1s" data-offset="100">
                <p style={{ fontSize: 30, lineHeight: 1, fontWeight: 900, margin: 0 }}>
                  The aim of Hong Kong Smart City Summit cum Smart City Awards 2018
                </p>
                is to recognise, promote and support innovative solutions and strategies that can potentially improve
                citizens’ lives by increasing efficiency, generating business and upgrading the quality of life. It is also
                to facilitate the development of future cities that are characterised by enhanced quality of life, robust
                innovation, advanced competitiveness and efficient management.
              </div>
              <div className="animate event_details" data-animate="slideInRight" data-duration="1.0s" data-delay="0.1s" data-offset="100">
                <div className="title">
                  <div className="title_text gradient">Event Details</div>
                </div>
                <div className="details_left">
                  <div className="date">Date:</div>
                  <div className="eleven">
                    <img src="/2018/images/11.png" alt="" />
                  </div>
                </div>
                <div className="details_right">
                  <div className="date venue">Venue:</div>
                  <div className="hkcec">
                    Hong Kong<br />
                    Convention and<br />
                    Exhibition Centre
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer2018 lang="en" />
    </>
  );
};

export default SmartCity2018;
